'use client';

// core (MUI)
import { faIR as faIRCore, arSD as arSDCore } from '@mui/material/locale';
// data grid (MUI)

// ----------------------------------------------------------------------
export const allLangs = [
  {
    value: 'fa',
    label: 'فارسی',
    countryCode: 'IR',
    adapterLocale: 'fa-IR',
    fontFamily: "IRANSans",
    numberFormat: { code: 'en', currency: 'IRR' },
    systemValue: {
      components: { ...faIRCore.components },
    },
  },
  {
    value: 'ar',
    label: 'Arabic',
    countryCode: 'SA',
    fontFamily: "Rubik",
    adapterLocale: 'ar-sa',
    numberFormat: { code: 'en', currency: 'AED' },
    systemValue: {
      components: { ...arSDCore.components },
    },
  },
];

/**
 * Country code:
 * https://flagcdn.com/en/codes.json
 *
 * Number format code:
 * https://gist.github.com/raushankrjha/d1c7e35cf87e69aa8b4208a8171a8416
 */
